import { render, staticRenderFns } from "./SelectCommunicationModal.vue?vue&type=template&id=7377de24&"
import script from "./SelectCommunicationModal.vue?vue&type=script&lang=js&"
export * from "./SelectCommunicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports